import { STATS } from "@/lib/site";

export default function StatsRow() {
  return (
    <section data-testid="stats-row" className="border-y border-brand-line bg-white">
      <div className="container-page py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <div key={i} className="text-center md:text-left" data-testid={`stat-${i}`}>
            <p className="font-heading text-4xl md:text-5xl font-extrabold tracking-tighter text-brand-ink">{s.value}</p>
            <p className="text-xs uppercase tracking-[0.2em] text-brand-ash mt-2">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
